import React from "react";
import { useTheme } from "@mui/material/styles";
import { colors } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { useTranslation } from "next-i18next";

import importAll from "../../../lib/utils/image";
import CloudinaryImage from "../../Common/CloudinaryImage";

const OurTeam = () => {
  const theme = useTheme();
  const { t } = useTranslation("about");
  const blocks = t("our_team.blocks", { returnObjects: true });
  const allImages = importAll(
    require.context(
      "../../../public/static/images/about/team",
      false,
      /\.(png|jpe?g|svg|webp)$/
    )
  );

  return (
    <Box>
      <Box marginBottom={5}>
        <Typography
          sx={{
            textTransform: "uppercase",
            fontWeight: "medium",
          }}
          gutterBottom
          color={"textSecondary"}
          align={"center"}
        >
          {t("our_team.title")}
        </Typography>
        <Box
          component={Typography}
          fontWeight={700}
          variant={"h3"}
          align={"center"}
        >
          {t("our_team.subtitle")}
        </Box>
      </Box>
      <Grid container spacing={2}>
        {blocks.map((item, i) => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <Box
              component={Card}
              borderRadius={3}
              boxShadow={2}
              sx={{
                textDecoration: "none",
                transition: "all .2s ease-in-out",
                "&:hover": {
                  transform: `translateY(-${theme.spacing(1 / 2)})`,
                },
              }}
            >
              <CardContent>
                <Avatar sx={{ height: 80, width: 80 }}>
                  <CloudinaryImage
                    component={Avatar}
                    src={allImages[item.avatar]}
                    alt={`Photo ${item.name}`}
                    height={80}
                    width={80}
                    placeholder="blur"
                    layout="fixed"
                  />
                </Avatar>
                <Box marginTop={4}>
                  <ListItemText primary={item.name} secondary={item.title} />
                  <Box marginTop={2}>
                    <Typography variant={"subtitle2"} color={"textSecondary"}>
                      {item.about}
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
              <CardActions>
                <IconButton
                  size={"small"}
                  sx={{
                    color: colors.blueGrey[200],
                  }}
                  href={item.linkedin}
                  target="_blank"
                >
                  <LinkedInIcon />
                </IconButton>
              </CardActions>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default OurTeam;
